import React from "react";

export default function Panel(props) {
  // eslint-disable-next-line react/prop-types
  return <div>{props.children}</div>;
}